import "core-js/modules/es.number.constructor.js";
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default defineComponent({
  name: 'AccordionItem',
  components: {
    CollapseTransition: CollapseTransition,
    AzIcon: AzIcon
  },
  props: {
    isOpened: Boolean,
    title: String,
    count: {
      type: Number,
      default: 0
    }
  }
});